import { render, staticRenderFns } from "./TableShareResource.vue?vue&type=template&id=2552c5ee&scoped=true"
import script from "./TableShareResource.vue?vue&type=script&lang=js"
export * from "./TableShareResource.vue?vue&type=script&lang=js"
import style0 from "./TableShareResource.vue?vue&type=style&index=0&id=2552c5ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2552c5ee",
  null
  
)

export default component.exports